export type ServiceFaq = { q: string; a: string };

export const SERVICE_FAQS: Record<string, ServiceFaq[]> = {
  "przeglad-instalacji-elektrycznej": [
    {
      q: "Ile kosztuje przegląd instalacji elektrycznej?",
      a: "Cena przeglądu instalacji elektrycznej w mieszkaniu wynosi zazwyczaj 200–400 zł, w zależności od metrażu i liczby obwodów. Dla domu jednorodzinnego koszt to zwykle 300–600 zł. Dokładna wycena zależy od lokalnego rynku i zakresu pomiarów — dlatego warto porównać oferty kilku firm.",
    },
    {
      q: "Jak często jest wymagany przegląd instalacji elektrycznej?",
      a: "Zgodnie z art. 62 ust. 1 pkt 2 Prawa budowlanego przegląd instalacji elektrycznej jest obowiązkowy co 5 lat dla wszystkich budynków. Zarządcy i ubezpieczyciele często wymagają aktualnego protokołu niezależnie od terminu ustawowego.",
    },
    {
      q: "Co zawiera protokół z przeglądu elektrycznego?",
      a: "Protokół zawiera wyniki pomiarów rezystancji izolacji, ochrony przeciwporażeniowej i ciągłości przewodów ochronnych, a także ocenę stanu rozdzielnicy i wnioski co do koniecznych napraw. Dokument podpisuje uprawniony elektryk z numerem SEP lub uprawnień budowlanych.",
    },
    {
      q: "Czy przegląd elektryczny jest obowiązkowy dla wynajmowanego mieszkania?",
      a: "Tak — właściciel nieruchomości odpowiada za stan techniczny instalacji. W przypadku pożaru spowodowanego wadliwą instalacją bez aktualnego przeglądu ubezpieczyciel może odmówić wypłaty odszkodowania. Dla wynajmujących aktualny protokół to też ochrona przed ewentualnymi roszczeniami najemcy.",
    },
  ],
  "przeglad-instalacji-odgromowej": [
    {
      q: "Jak często trzeba wykonywać przegląd instalacji odgromowej?",
      a: "Prawo budowlane (art. 62 ust. 1 pkt 2) wymaga przeglądu co 5 lat. Norma PN-EN 62305-3 zaleca dodatkowo kontrolę po każdym uderzeniu pioruna w obiekt lub jego pobliże, a w przypadku instalacji chroniących obiekty zagrożone wybuchem — co rok.",
    },
    {
      q: "Co jest sprawdzane podczas przeglądu piorunochronu?",
      a: "Technik mierzy rezystancję uziemienia (powinna być ≤ 10 Ω), sprawdza stan zwodów, odprowadzaczy pionowych i poziomych, złączy probierczych oraz uziomów. Oceniana jest też korozja elementów i ciągłość połączeń wyrównawczych.",
    },
    {
      q: "Kto może wykonać przegląd instalacji odgromowej?",
      a: "Przegląd może wykonać osoba posiadająca uprawnienia budowlane w specjalności instalacyjnej w zakresie sieci, instalacji i urządzeń elektrycznych lub elektroenergetycznych. W praktyce są to elektrycy z uprawnieniami SEP lub E i D grupy 1.",
    },
    {
      q: "Czy stary budynek bez piorunochronu musi go mieć zainstalowany?",
      a: "Obowiązek instalacji piorunochronu zależy od klasy zagrożenia piorunowego budynku, określanej na podstawie normy PN-EN 62305-2. Wiele budynków mieszkalnych wybudowanych przed 1970 r. nie ma piorunochronu i formalnie nie musi — jednak brak ochrony podnosi ryzyko ubezpieczeniowe i może być przeszkodą przy sprzedaży.",
    },
  ],
  "pomiary-elektryczne": [
    {
      q: "Kiedy trzeba wykonać pomiary elektryczne?",
      a: "Pomiary wykonuje się przy odbiorze nowej lub przebudowanej instalacji, po remoncie, po rozbudowie rozdzielni, po awarii, zalaniu lub przepięciu oraz w ramach obowiązkowej kontroli co najmniej raz na 5 lat. Często są też potrzebne przed wynajmem, sprzedażą nieruchomości albo odbiorem robót przez inwestora.",
    },
    {
      q: "Co obejmują pomiary elektryczne instalacji?",
      a: "Najczęściej pomiar rezystancji izolacji, ciągłości przewodów ochronnych, impedancji pętli zwarcia, testy RCD oraz ocenę uziemienia. Zakres badań dobiera się do celu wizyty: odbioru, kontroli okresowej albo diagnostyki konkretnej usterki.",
    },
    {
      q: "Czy po pomiarach elektrycznych otrzymuje się protokół?",
      a: "Tak. Protokół zawiera zakres badania, wyniki pomiarów, ocenę stanu instalacji i wnioski końcowe. To dokument potrzebny przy odbiorach, dla zarządcy obiektu, ubezpieczyciela oraz do planowania napraw i modernizacji.",
    },
    {
      q: "Ile kosztują pomiary elektryczne?",
      a: "W małym mieszkaniu koszt wynosi zwykle około 200–400 zł, a w domu najczęściej od 300 zł wzwyż. Na wycenę wpływa liczba obwodów, zakres badań, rozdzielnia, potrzeba pomiaru uziemienia i rodzaj protokołu końcowego.",
    },
  ],
  "przeglad-instalacji-fotowoltaicznej": [
    {
      q: "Czy przegląd instalacji fotowoltaicznej jest obowiązkowy?",
      a: "Instalacja fotowoltaiczna jest częścią instalacji elektrycznej budynku, więc jej stan powinien być uwzględniany w obowiązkowej kontroli instalacji elektrycznej wykonywanej co najmniej raz na 5 lat. W praktyce instalację PV warto sprawdzać częściej, zwykle co 1–2 lata lub po burzy, gradobiciu i spadku uzysków.",
    },
    {
      q: "Co obejmuje przegląd instalacji fotowoltaicznej?",
      a: "Kontrola obejmuje panele, mocowania, przewody, złącza, okablowanie DC i AC, zabezpieczenia oraz falownik. W zależności od zakresu zlecenia dochodzą też pomiary i ocena współpracy instalacji PV z rozdzielnią oraz resztą instalacji budynku.",
    },
    {
      q: "Czy falownik i magazyn energii też trzeba sprawdzać?",
      a: "Tak. Falownik jest jednym z kluczowych elementów systemu, a magazyn energii wpływa na logikę pracy, zabezpieczenia i komunikację całego układu. Panele mogą wyglądać poprawnie, a realny problem może leżeć właśnie w falowniku albo integracji urządzeń.",
    },
    {
      q: "Ile kosztuje przegląd instalacji fotowoltaicznej?",
      a: "Cena zależy od mocy instalacji, dostępu do dachu, zakresu pomiarów i tego, czy system współpracuje z magazynem energii. Proste instalacje domowe wycenia się zwykle od kilkuset złotych, a bardziej rozbudowane układy firmowe wymagają indywidualnej wyceny.",
    },
  ],
  "przeglad-magazynu-energii": [
    {
      q: "Kiedy warto wykonać przegląd magazynu energii?",
      a: "Po uruchomieniu systemu, po rozbudowie instalacji PV, po zmianie falownika, przed końcem gwarancji i zawsze po alarmach, nietypowym nagrzewaniu lub spadku pojemności. Dodatkowa kontrola ma sens także po burzy, przepięciu albo dłuższym postoju systemu.",
    },
    {
      q: "Co obejmuje przegląd magazynu energii?",
      a: "Ocenę połączeń, zabezpieczeń DC i AC, pracy systemu BMS, komunikacji z falownikiem, warunków chłodzenia oraz historii alarmów. Celem jest potwierdzenie, że magazyn pracuje stabilnie, bezpiecznie i zgodnie z konfiguracją całego układu.",
    },
    {
      q: "Czy magazyn energii trzeba sprawdzać razem z fotowoltaiką?",
      a: "Tak, jeśli współpracuje z instalacją PV. Wiele problemów wynika nie z samej baterii, lecz z konfiguracji falownika, zabezpieczeń, rozdzielni albo komunikacji między urządzeniami, dlatego najlepiej oceniać cały system jako całość.",
    },
    {
      q: "Ile kosztuje przegląd magazynu energii?",
      a: "Cena zależy od typu systemu, pojemności, producenta, poziomu integracji z falownikiem i zakresu diagnostyki. Prosty domowy przegląd kosztuje mniej niż analiza rozbudowanego układu backupowego z dodatkowymi pomiarami i szczegółowym raportem.",
    },
  ],
  "rozdzielnia-elektryczna": [
    {
      q: "Kiedy rozdzielnia elektryczna wymaga wymiany?",
      a: "Zwykle wtedy, gdy jest przegrzana, zbyt mała, uszkodzona mechanicznie, ma prowizoryczne przeróbki lub nie da się jej bezpiecznie dostosować do obecnych obciążeń. Częstym sygnałem są też częste wyłączenia zabezpieczeń i brak miejsca na nowe obwody.",
    },
    {
      q: "Co sprawdza się podczas kontroli rozdzielni elektrycznej?",
      a: "Stan obudowy, aparatury, połączeń, oznaczeń obwodów, działanie zabezpieczeń i przygotowanie układu pod obecne obciążenia. W razie potrzeby kontrolę uzupełnia się pomiarami i oceną doboru zabezpieczeń.",
    },
    {
      q: "Kiedy wystarcza modernizacja, a kiedy potrzebna jest pełna wymiana?",
      a: "Modernizacja wystarcza, jeśli układ jest zasadniczo sprawny, ale wymaga uporządkowania, dołożenia RCD lub ograniczników przepięć i wymiany części aparatury. Wymiana ma sens, gdy stara tablica nie daje się bezpiecznie rozbudować albo jej stan techniczny jest zły.",
    },
    {
      q: "Ile kosztuje modernizacja lub wymiana rozdzielni elektrycznej?",
      a: "Koszt zależy od liczby obwodów, liczby faz, zakresu prac przy okablowaniu, jakości aparatury i tego, czy po zakończeniu są wykonywane pomiary oraz dokumentacja. Mała rozdzielnia w mieszkaniu jest wyceniana inaczej niż układ w domu, lokalu lub budynku firmowym.",
    },
  ],
  "badanie-termowizyjne": [
    {
      q: "Na czym polega badanie termowizyjne instalacji elektrycznej?",
      a: "Kamera termowizyjna rejestruje emisję podczerwieni z powierzchni elementów elektrycznych podczas ich pracy pod obciążeniem. Miejsca o podwyższonej temperaturze (złe połączenia, przeciążone obwody, wadliwe wyłączniki) są widoczne na termogramie jako cieplejsze punkty. Wynik to raport z fotografiami i opisem zalecanych napraw.",
    },
    {
      q: "Kiedy warto wykonać badanie termowizyjne?",
      a: "Badanie jest szczególnie zalecane przed zawarciem lub odnowieniem polisy ubezpieczeniowej, po remoncie lub rozbudowie instalacji oraz gdy w budynku zdarzają się niewyjaśnione zadziałania bezpieczników. Wiele towarzystw ubezpieczeniowych akceptuje termografię jako alternatywę dla klasycznego przeglądu elektrycznego.",
    },
    {
      q: "Czy badanie termowizyjne zastępuje przegląd elektryczny?",
      a: "Nie do końca — termowizja wykrywa problemy cieplne, ale nie zastępuje pomiarów elektrycznych (rezystancji izolacji, ochrony przeciwporażeniowej). Oba badania są komplementarne: termografia jest szybsza i nie wymaga odłączania instalacji, ale pełny protokół z pomiarami jest wymagany przez Prawo budowlane.",
    },
    {
      q: "Jak długo trwa badanie termowizyjne i czy wymaga wyłączenia prądu?",
      a: "Badanie wykonuje się przy normalnie pracującej instalacji — wyłączanie prądu nie jest potrzebne ani wskazane, bo kamera mierzy temperatury pod obciążeniem. Czas trwania zależy od wielkości obiektu: mieszkanie to 30–60 minut, hala produkcyjna lub biurowiec — kilka godzin.",
    },
  ],
  "przeglad-instalacji-gazowej": [
    {
      q: "Jak często jest wymagany przegląd instalacji gazowej?",
      a: "Zgodnie z art. 62 ust. 1 pkt 1 lit. c Prawa budowlanego przegląd gazowy jest obowiązkowy co rok dla wszystkich budynków z instalacją gazową. Termin dotyczy zarówno mieszkań, domów jednorodzinnych, jak i budynków komercyjnych.",
    },
    {
      q: "Ile kosztuje przegląd instalacji gazowej w mieszkaniu?",
      a: "Cena przeglądu gazowego mieszkania to zazwyczaj 100–250 zł. Na cenę wpływa liczba urządzeń gazowych (kuchenka, kocioł, podgrzewacz), metraż i lokalizacja. Dla domu jednorodzinnego z kotłem i kuchnią koszt wynosi zwykle 200–400 zł.",
    },
    {
      q: "Co sprawdza technik podczas przeglądu gazowego?",
      a: "Technik kontroluje szczelność połączeń, stan kurków odcinających, ciągłość i stan przewodów elastycznych oraz sprawność urządzeń gazowych. Obowiązkowo sprawdzany jest też ciąg kominowy i wentylacja w pomieszczeniu — niewystarczający ciąg uniemożliwia bezpieczną pracę kotła lub kuchenki.",
    },
    {
      q: "Co grozi za brak przeglądu instalacji gazowej?",
      a: "Brak przeglądu to naruszenie Prawa budowlanego. Zarządca lub właściciel może otrzymać nakaz usunięcia nieprawidłowości lub decyzję o wstrzymaniu dostawy gazu. W przypadku wypadku gazowego brak protokołu może oznaczać odpowiedzialność karną i odmowę odszkodowania przez ubezpieczyciela.",
    },
  ],
  "przeglad-kotla-gazowego": [
    {
      q: "Jak często powinno się serwisować kocioł gazowy?",
      a: "Producenci kotłów wymagają corocznego serwisu do utrzymania gwarancji. Prawo budowlane nakazuje przegląd instalacji gazowej (w tym kotła) raz w roku. Serwis najlepiej wykonać na początku sezonu grzewczego, by mieć pewność sprawności kotła przed zimą.",
    },
    {
      q: "Co obejmuje serwis kotła gazowego?",
      a: "Standardowy serwis obejmuje czyszczenie palnika i wymiennika ciepła, pomiar spalin (CO, CO₂, sprawność), regulację parametrów spalania, kontrolę zabezpieczeń termostatycznych i manometrów, sprawdzenie uszczelnień i odpowietrzenie instalacji c.o.",
    },
    {
      q: "Jak rozpoznać, że kocioł gazowy wymaga serwisu?",
      a: "Sygnałem alarmowym jest wzrost zużycia gazu przy niezmienionym trybie pracy, nieregularne zapalanie palnika, hałasy podczas pracy, niestabilne ciśnienie wody lub migający kod błędu na wyświetlaczu. Każdy z tych objawów powinien skutkować wizytą serwisanta.",
    },
    {
      q: "Czy stary kocioł gazowy warto naprawiać czy wymienić?",
      a: "Kotły starsze niż 15 lat mają sprawność ok. 80–85%, podczas gdy nowoczesne kondensacyjne osiągają ponad 100% sprawności nominalnej. Wymiana często zwraca się w rachunkach za gaz w ciągu 3–5 lat. Serwisant po przeglądzie może ocenić, czy remont jest ekonomicznie uzasadniony.",
    },
  ],
  "proba-szczelnosci-gazu": [
    {
      q: "Kiedy wykonuje się próbę szczelności gazu?",
      a: "Najczęściej po wykonaniu nowej instalacji, po przebudowie, po naprawie, po wymianie fragmentu przewodów albo przed ponownym uruchomieniem instalacji, która była wyłączona z użytkowania. To badanie typowe dla momentu odbioru i uruchomienia instalacji, a nie zamiennik corocznego przeglądu gazowego.",
    },
    {
      q: "Czy próba szczelności gazu jest obowiązkowa?",
      a: "Co do zasady tak, jeśli mówimy o nowej, przebudowywanej albo naprawianej instalacji gazowej przed jej odbiorem lub ponownym uruchomieniem. Próba ma potwierdzić, że układ jest szczelny i może zostać bezpiecznie dopuszczony do dalszego użytkowania.",
    },
    {
      q: "Czy po próbie szczelności gazu otrzymuje się protokół?",
      a: "Tak. Po wykonaniu badania standardem jest protokół, który potwierdza zakres próby, wynik oraz podstawowe dane instalacji i obiektu. To dokument potrzebny do odbioru, dokumentacji technicznej i dalszego uruchomienia instalacji po wykonanych pracach.",
    },
    {
      q: "Ile kosztuje próba szczelności instalacji gazowej?",
      a: "Cena zależy od wielkości instalacji, liczby badanych odcinków, złożoności układu i tego, czy usługa obejmuje tylko samo badanie, czy również diagnostykę po negatywnym wyniku. Prosta próba dla mieszkania lub domu jest wyceniana inaczej niż badanie większej instalacji po szerszej przebudowie.",
    },
  ],
  "odbior-instalacji-gazowej": [
    {
      q: "Kiedy wykonuje się odbiór instalacji gazowej?",
      a: "Po zakończeniu robót związanych z wykonaniem nowej instalacji albo istotną przebudową istniejącego układu. To etap poprzedzający przekazanie instalacji do użytkowania, zakończenie budowy albo dalsze formalności związane z uruchomieniem obiektu.",
    },
    {
      q: "Jakie dokumenty są potrzebne do odbioru instalacji gazowej?",
      a: "Najczęściej potrzebne są projekt techniczny lub dokumentacja powykonawcza, oświadczenie kierownika budowy o zgodności wykonania z projektem i przepisami oraz protokół próby szczelności instalacji gazowej. W zależności od inwestycji dochodzą też inne protokoły badań, dziennik budowy i dodatkowe załączniki wymagane przy zakończeniu budowy.",
    },
    {
      q: "Czy przy odbiorze instalacji gazowej wykonuje się próbę szczelności?",
      a: "Tak. Próba szczelności jest jednym z kluczowych elementów weryfikowanych przy odbiorze instalacji gazowej. To właśnie ona potwierdza, że przewody i połączenia są szczelne, a instalacja może zostać bezpiecznie przekazana do dalszego użytkowania lub kolejnego etapu formalnego.",
    },
    {
      q: "Ile kosztuje odbiór instalacji gazowej?",
      a: "Cena odbioru zależy od wielkości instalacji, rodzaju obiektu i zakresu czynności objętych wizytą. Prosta instalacja w domu jednorodzinnym jest wyceniana inaczej niż odbiór w lokalu usługowym albo większym budynku, zwłaszcza jeśli usługa obejmuje analizę dokumentacji i dodatkowe badania.",
    },
  ],
  "przeglad-systemow-wykrywania-pozaru": [
    {
      q: "Na czym polega przegląd systemów wykrywania pożaru?",
      a: "Przegląd polega na sprawdzeniu, czy system wykrywa zagrożenie, poprawnie uruchamia alarm i zachowuje sprawność poszczególnych elementów. W praktyce kontrola obejmuje centrale, czujki, sygnalizatory, zasilanie oraz dokumentację eksploatacyjną.",
    },
    {
      q: "Jak często należy wykonywać przegląd systemów wykrywania pożaru?",
      a: "Częstotliwość zależy od rodzaju systemu, producenta i charakteru obiektu, ale regularne przeglądy i konserwacja są konieczne. W praktyce stosuje się harmonogramy obejmujące zarówno częstsze czynności konserwacyjne, jak i bardziej kompleksowe przeglądy okresowe.",
    },
    {
      q: "Czy przegląd obejmuje czujniki dymu, czujniki ciepła i centralę SSP?",
      a: "Tak. Podczas kontroli sprawdza się stan czujek, reakcję na test, zabrudzenie, sposób montażu, centralę, sygnalizatory, zasilanie podstawowe i awaryjne oraz podstawowe funkcje alarmowe całego układu.",
    },
    {
      q: "Czy po przeglądzie systemu wykrywania pożaru otrzymuje się protokół?",
      a: "Tak. Po przeglądzie powinna zostać przygotowana dokumentacja potwierdzająca wykonanie czynności serwisowych, stan systemu i wykryte usterki. To podstawa dalszej eksploatacji oraz planowania napraw lub konserwacji.",
    },
  ],
  "przeglad-klimatyzacji": [
    {
      q: "Jak często należy wykonywać przegląd klimatyzacji?",
      a: "Najbezpieczniej wykonywać serwis klimatyzacji co najmniej raz w roku, najlepiej przed sezonem letnim. Jeśli urządzenie pracuje intensywnie przez większą część roku, na przykład w biurze lub lokalu usługowym, warto robić serwis dwa razy w roku.",
    },
    {
      q: "Co obejmuje przegląd klimatyzacji?",
      a: "Typowy przegląd obejmuje kontrolę filtrów, wymienników, wentylatorów, odpływu skroplin, połączeń elektrycznych i podstawowych parametrów pracy urządzenia. W praktyce często dochodzi też czyszczenie i dezynfekcja jednostki wewnętrznej.",
    },
    {
      q: "Czy przegląd klimatyzacji obejmuje czyszczenie urządzenia?",
      a: "Tak, typowy serwis obejmuje podstawowe czyszczenie filtrów, parownika, obudowy i odpływu skroplin. Warto jednak sprawdzić zakres oferty, bo głębsze czyszczenie chemiczne albo rozszerzona dezynfekcja mogą być rozliczane osobno.",
    },
    {
      q: "Ile kosztuje przegląd klimatyzacji?",
      a: "Cena zależy od typu urządzenia, liczby jednostek i zakresu czyszczenia oraz diagnostyki. Pojedynczy klimatyzator typu split w mieszkaniu jest wyceniany inaczej niż kilka jednostek w domu, biurze albo lokalu usługowym.",
    },
  ],
  "przeglad-pompy-ciepla": [
    {
      q: "Jak często należy wykonywać serwis pompy ciepła?",
      a: "Najczęściej zaleca się wykonywanie serwisu pompy ciepła raz w roku. To podejście odpowiada praktyce producentów i pozwala sprawdzić urządzenie przed kolejnym sezonem intensywnej pracy.",
    },
    {
      q: "Czy przegląd pompy ciepła jest wymagany do utrzymania gwarancji?",
      a: "Bardzo często tak. Wielu producentów wiąże utrzymanie gwarancji z regularnym serwisem wykonywanym zgodnie z warunkami gwarancyjnymi. Brak potwierdzonego serwisu może później utrudnić dochodzenie roszczeń gwarancyjnych.",
    },
    {
      q: "Co obejmuje serwis pompy ciepła?",
      a: "Serwis obejmuje sprawdzenie parametrów pracy urządzenia, ocenę stanu jednostki, filtrów, połączeń hydraulicznych i elektrycznych oraz działania automatyki sterującej. W zależności od typu pompy ocenia się też współpracę z buforem, zasobnikiem i instalacją grzewczą.",
    },
    {
      q: "Ile kosztuje przegląd pompy ciepła?",
      a: "Cena zależy od typu pompy ciepła, zakresu serwisu i stopnia rozbudowania całej instalacji. Prosty układ w domu jednorodzinnym wycenia się inaczej niż system z buforem, zasobnikiem ciepłej wody, kilkoma obiegami i szerszą automatyką.",
    },
  ],
  "przeglad-gasnic": [
    {
      q: "Jak często gaśnica wymaga przeglądu?",
      a: "Rozporządzenie MSWiA z 2010 r. wymaga przeglądu gaśnic raz w roku. Niezależnie od wskazań manometru, każda gaśnica musi być sprawdzona przez uprawnioną serwisownię i mieć aktualną nalepkę z datą następnego przeglądu.",
    },
    {
      q: "Co grozi za brak ważnego przeglądu gaśnicy?",
      a: "Gaśnica bez aktualnego przeglądu jest traktowana jako niesprawna i nie może figurować w wykazie wyposażenia przeciwpożarowego. W przypadku kontroli straży pożarnej właściciel lub zarządca może otrzymać mandat i nakaz uzupełnienia wyposażenia. W obiektach komercyjnych brak sprawnych gaśnic może skutkować nakazem zamknięcia.",
    },
    {
      q: "Ile lat służy gaśnica?",
      a: "Trwałość gaśnicy zależy od typu: gaśnice proszkowe nadają się do użytku przez ok. 10 lat od daty produkcji, CO₂ — do 10 lat, a pianowe i wodne — ok. 5–10 lat. Po tym czasie należy je wycofać z eksploatacji lub poddać gruntownemu przeglądowi z wymianą środka gaśniczego.",
    },
    {
      q: "Czy muszę mieć gaśnicę w mieszkaniu?",
      a: "Polskie prawo nie nakłada obowiązku posiadania gaśnicy w mieszkaniu prywatnym, ale w budynkach wielorodzinnych gaśnice muszą być na klatkach schodowych i w piwnicach. W przypadku najmu krótkoterminowego (Airbnb) i działalności gospodarczej w lokalu posiadanie gaśnicy jest wymogiem formalnym.",
    },
  ],
  "przeglad-hydrantow": [
    {
      q: "Jak często powinny być przeglądane hydranty wewnętrzne?",
      a: "Zgodnie z normą PN-EN 671-3 hydranty wewnętrzne wymagają corocznego przeglądu konserwacyjnego. Dodatkowo po każdym użyciu (np. po gaszeniu pożaru lub ćwiczeniu ewakuacyjnym) hydrant powinien być sprawdzony przez serwisanta i odnotowany w książce obiektu.",
    },
    {
      q: "Co sprawdza się podczas przeglądu hydrantów?",
      a: "Technik mierzy ciśnienie statyczne i dynamiczne wody przy hydrancie, sprawdza szczelność zaworu kulowego, stan węża (brak pęknięć, złączy), sprawność prądownicy i oznakowanie hydrantu. Dostęp do hydrantu nie może być blokowany żadnymi przedmiotami.",
    },
    {
      q: "Czy hydranty zewnętrzne też wymagają przeglądu?",
      a: "Tak — hydranty zewnętrzne podlegają corocznym przeglądom przez właściciela sieci wodociągowej lub zarządcę terenu. Zarządca budynku jest odpowiedzialny za zgłaszanie awarii hydrantów zewnętrznych zlokalizowanych na działce, na której stoi budynek.",
    },
    {
      q: "Czy brak sprawnych hydrantów może skutkować zamknięciem budynku?",
      a: "Tak — niesprawne lub nieoznakowane hydranty są podstawą do wydania przez Komendanta Straży Pożarnej decyzji nakazującej usunięcie uchybień, a w przypadku poważnych zagrożeń — do zakazu użytkowania budynku. Dotyczy to szczególnie budynków użyteczności publicznej i zamieszkania zbiorowego.",
    },
  ],
  "przeglad-systemow-sygnalizacji-pozaru": [
    {
      q: "Jak często system SSP/SAP wymaga konserwacji?",
      a: "Norma PN-EN 54-14 wymaga konserwacji kwartalnej (test czujników i centrali, kontrola akumulatorów) oraz corocznego przeglądu kompleksowego. W obiektach o podwyższonym ryzyku (szpitale, hotele, centra handlowe) zalecana jest konserwacja miesięczna.",
    },
    {
      q: "Kto może serwisować systemy sygnalizacji pożaru?",
      a: "Serwis może wykonywać firma posiadająca certyfikat autoryzowanego serwisu producenta centrali lub firma z potwierdzonym przeszkoleniem technicznym. Technik musi posiadać kurs z zakresu systemów SSP/SAP oraz uprawnienia elektryczne w zakresie pomiarów i konserwacji.",
    },
    {
      q: "Co zrobić gdy system SSP generuje fałszywe alarmy?",
      a: "Fałszywe alarmy to najczęstszy problem SSP i wynikają z zabrudzonych czujników, wilgoci, owadów lub błędnej konfiguracji. Technik serwisowy powinien skalibrować lub wymienić czujniki i przeprogramować strefy opóźnienia alarmu. Zbyt częste fałszywe alarmy narażają na koszty interwencji straży i uczą mieszkańców ignorować sygnały alarmowe.",
    },
    {
      q: "Czy system SSP jest obowiązkowy w każdym budynku?",
      a: "Nie — SSP jest wymagany w budynkach ZL I i ZL II (budynki użyteczności publicznej, zamieszkania zbiorowego) o określonej powierzchni, w hotelach, szpitalach i budynkach wysokich. W budownictwie mieszkalnym wielorodzinnym wymagane są jedynie czujniki dymu w określonych strefach.",
    },
  ],
  "przeglad-kominiarski": [
    {
      q: "Jak często jest wymagany przegląd kominiarski?",
      a: "Prawo budowlane (art. 62 ust. 1 pkt 1 lit. c) wymaga corocznego przeglądu przewodów kominowych. Niezależnie od tego, przewody dymowe (przy kominku lub kotle na paliwo stałe) powinny być czyszczone co 3 miesiące w sezonie grzewczym, a gazowe — raz w roku.",
    },
    {
      q: "Czy przegląd kominiarski jest wymagany przy zakupie ubezpieczenia?",
      a: "Tak — większość ubezpieczycieli wymaga aktualnego protokołu kominiarskiego jako warunek zawarcia lub odnowienia polisy nieruchomości. W przypadku pożaru spowodowanego niedrożnym kominem bez aktualnego przeglądu towarzystwo może odmówić wypłaty odszkodowania.",
    },
    {
      q: "Co grozi jeśli komin jest niedrożny?",
      a: "Niedrożny przewód kominowy uniemożliwia odprowadzenie spalin, co prowadzi do wzrostu stężenia CO w pomieszczeniu. Tlenek węgla jest bezwonny i szybko powoduje utratę przytomności — w Polsce dochodzi do kilkuset zatruć rocznie, z których część jest śmiertelna. Niedrożność może też powodować cofanie się dymu i pożar w obrębie komina.",
    },
    {
      q: "Kto może wykonać przegląd kominiarski?",
      a: "Przegląd musi wykonać mistrz kominiarski lub osoba z uprawnieniami kominiarskimi. Protokół z podpisem i pieczęcią kominiarza jest wymagany przez prawo budowlane, ubezpieczycieli i zarządców nieruchomości. Samodzielne czyszczenie komina przez właściciela nie zastępuje formalnego przeglądu.",
    },
  ],
  "przeglad-wentylacji": [
    {
      q: "Jak często powinien być serwisowany rekuperator?",
      a: "Filtry rekuperatora należy czyścić lub wymieniać co 3 miesiące w sezonie grzewczym i co 6 miesięcy latem. Kompleksowy serwis centrali wentylacyjnej, obejmujący czyszczenie wymiennika i pomiar przepływów, zaleca się raz w roku.",
    },
    {
      q: "Po czym poznać, że wentylacja mechaniczna wymaga przeglądu?",
      a: "Sygnałami są: wzrost głośności pracy centrali, zmniejszona ilość nawiewanego powietrza, nieprzyjemny zapach z nawiewników, wyższe rachunki za energię lub migający alarm serwisowy na sterowaniu. Brudne filtry to najczęstsza przyczyna — ich zaniedbanie może uszkodzić silnik wentylatora.",
    },
    {
      q: "Czy zły stan wentylacji wpływa na zdrowie?",
      a: "Tak — niesprzątnięty rekuperator i brudne kanały wentylacyjne sprzyjają rozwojowi pleśni i bakterii (w tym Legionella w układach z chłodzeniem). W biurach i szkołach zła wentylacja obniża koncentrację i zwiększa absencję chorobową. Norma PN-EN 13779 określa minimalne wymagania dla jakości powietrza wewnętrznego.",
    },
    {
      q: "Czy wentylacja grawitacyjna też wymaga przeglądu?",
      a: "Tak — wentylacja grawitacyjna (kratki wentylacyjne w ścianie podłączone do pionów) podlega corocznej kontroli kominiarskiej. Drożność kratek wentylacyjnych w kuchni i łazience wpływa bezpośrednio na prawidłową pracę urządzeń gazowych i eliminację wilgoci z pomieszczeń.",
    },
  ],
  "przeglad-budowlany": [
    {
      q: "Kto jest zobowiązany do przeprowadzenia przeglądu budowlanego?",
      a: "Obowiązek spoczywa na właścicielu lub zarządcy obiektu budowlanego. Dotyczy to zarówno osób fizycznych (dom jednorodzinny), jak i wspólnot mieszkaniowych, spółdzielni, firm i instytucji. Za brak przeglądu odpowiada prawnie właściciel lub zarządca wskazany w księdze wieczystej.",
    },
    {
      q: "Na czym polega różnica między przeglądem rocznym a pięcioletnim?",
      a: "Coroczny przegląd obejmuje kontrolę elementów narażonych na uszkodzenie (dachu, rynien, instalacji zewnętrznych) i ocenę wymagającą natychmiastowej interwencji. Przegląd pięcioletni jest bardziej szczegółowy — obejmuje ocenę stanu technicznego całości budynku, estetyki elewacji i sprawności instalacji, łącznie z instalacją elektryczną i gazową.",
    },
    {
      q: "Co grozi za brak przeglądu budowlanego?",
      a: "Brak przeglądu lub nierzetelna jego dokumentacja grozi grzywną do 5000 zł (art. 93 Prawa budowlanego) i może skutkować nakazem wykonania robót budowlanych przywracających właściwy stan obiektu. W przypadku wypadku spowodowanego złym stanem technicznym budynku bez aktualnego przeglądu właściciel ponosi pełną odpowiedzialność karną i cywilną.",
    },
    {
      q: "Ile kosztuje przegląd budowlany?",
      a: "Cena przeglądu ogólnobudowlanego zależy od wielkości obiektu. Dla domu jednorodzinnego to zwykle 300–600 zł, dla bloku wielorodzinnego 800–2500 zł, a dla obiektu komercyjnego o dużej powierzchni — kilka tysięcy złotych. Warto zebrać oferty od kilku inspektorów z uprawnieniami budowlanymi.",
    },
  ],
  "przeglad-sprzetu-przeciwpozarowego": [
    {
      q: "Czy przegląd sprzętu przeciwpożarowego jest obowiązkowy?",
      a: "Tak. Sprzęt i urządzenia przeciwpożarowe w obiekcie powinny być regularnie kontrolowane i konserwowane. Dla właściciela albo zarządcy nie jest to temat dodatkowy, lecz element prawidłowego utrzymania budynku i jego dokumentacji.",
    },
    {
      q: "Jak często należy wykonywać przegląd gaśnic i hydrantów?",
      a: "Gaśnice i hydranty powinny być objęte przeglądami technicznymi i czynnościami konserwacyjnymi zgodnie z zasadami określonymi przez producenta, nie rzadziej niż raz w roku. Tylko taka kontrola pozwala potwierdzić, że sprzęt jest gotowy do działania.",
    },
    {
      q: "Co obejmuje przegląd sprzętu PPOŻ?",
      a: "Zakres usługi zależy od rodzaju urządzeń w obiekcie, ale zwykle obejmuje oględziny, podstawowe próby funkcjonalne, ocenę kompletności wyposażenia, sprawdzenie oznaczeń, plomb i gotowości urządzeń do użycia. Po kontroli właściciel powinien wiedzieć, które elementy są sprawne, a które wymagają naprawy lub wymiany.",
    },
    {
      q: "Ile kosztuje przegląd sprzętu przeciwpożarowego?",
      a: "Cena zależy od liczby urządzeń, rodzaju obiektu i zakresu czynności przewidzianych do wykonania. Inaczej wycenia się pojedyncze gaśnice w małym lokalu, a inaczej pakiet obejmujący gaśnice, hydranty, dokumentację i większą liczbę punktów w budynku.",
    },
  ],
  "przeglad-zabezpieczen-ewakuacyjnych-i-przeciwpozarowych": [
    {
      q: "Czy przegląd zabezpieczeń ewakuacyjnych i przeciwpożarowych jest obowiązkowy?",
      a: "Tak. Zabezpieczenia przeciwpożarowe stosowane w obiekcie powinny być utrzymywane w stanie sprawności technicznej i funkcjonalnej oraz objęte regularnymi przeglądami i konserwacją. Obowiązek nie kończy się na samym montażu urządzeń.",
    },
    {
      q: "Co obejmuje przegląd zabezpieczeń ewakuacyjnych?",
      a: "Zakres zależy od rodzaju urządzeń zastosowanych w obiekcie, ale zwykle obejmuje oględziny, podstawowe testy funkcjonalne, ocenę kompletności i stanu technicznego, a także weryfikację dokumentacji oraz oznakowania. Najczęściej dotyczy oświetlenia ewakuacyjnego, drzwi przeciwpożarowych i systemów oddymiania.",
    },
    {
      q: "Czy oświetlenie ewakuacyjne i drzwi przeciwpożarowe muszą być kontrolowane?",
      a: "Tak. Oświetlenie ewakuacyjne powinno być regularnie sprawdzane pod kątem działania po zaniku napięcia i czasu pracy na zasilaniu awaryjnym, a drzwi przeciwpożarowe pod kątem domykania, stanu okuć, uszczelek i zachowania funkcji pożarowej.",
    },
    {
      q: "Ile kosztuje przegląd zabezpieczeń przeciwpożarowych?",
      a: "Cena zależy od rodzaju zabezpieczeń, liczby urządzeń, wielkości budynku i zakresu testów przewidzianych do wykonania. Inaczej wycenia się prostszą kontrolę pojedynczych elementów, a inaczej szerszy przegląd obejmujący kilka systemów, dokumentację i większy obiekt.",
    },
  ],
};

export function getServiceFaqs(slug: string): ServiceFaq[] {
  return SERVICE_FAQS[slug] ?? [];
}
